<div class="page">
    <div class="page-head">
        <div>
            <h2>{{ pageTitle() }}</h2>
            <p>Manage states (e.g. "Madhya Pradesh") used to tag a client's regional offices.</p>
        </div>
        <p-button label="Add State" icon="pi pi-plus" (onClick)="openAdd()" />
    </div>

    <div class="card">
        <div class="toolbar">
            <p-iconfield iconPosition="left" class="search-field">
                <p-inputicon styleClass="pi pi-search" />
                <input type="text" pInputText placeholder="Search state..."
                    [ngModel]="search()" (ngModelChange)="search.set($event)">
            </p-iconfield>
            <span class="count">{{ filtered().length }} of {{ rows().length }}</span>
        </div>

        <p-table [value]="filtered()" [loading]="loading()" dataKey="id" [rows]="10"
            [paginator]="filtered().length > 10" [rowsPerPageOptions]="[10, 25, 50]"
            styleClass="p-datatable-sm" [showCurrentPageReport]="true"
            currentPageReportTemplate="Showing {first}–{last} of {totalRecords}">
            <ng-template pTemplate="header">
                <tr>
                    <th>State</th>
                    <th>Status</th>
                    <th class="ta-r">Actions</th>
                </tr>
            </ng-template>
            <ng-template pTemplate="body" let-r>
                <tr>
                    <td class="name">{{ r.stateName }}</td>
                    <td>
                        <p-tag [value]="r.isActive ? 'ACTIVE' : 'INACTIVE'"
                            [severity]="r.isActive ? 'success' : 'secondary'"
                            (click)="toggleActive(r)" styleClass="clickable" pTooltip="Click to toggle" />
                    </td>
                    <td class="ta-r actions">
                        <p-button icon="pi pi-pencil" [rounded]="true" [text]="true" severity="secondary"
                            pTooltip="Edit" (onClick)="openEdit(r)" />
                        <p-button icon="pi pi-trash" [rounded]="true" [text]="true" severity="danger"
                            pTooltip="Delete" (onClick)="remove(r)" />
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
                <tr>
                    <td colspan="3">
                        <div class="state"><i class="pi pi-inbox"></i><p>No states found.</p></div>
                    </td>
                </tr>
            </ng-template>
        </p-table>
    </div>
</div>

<!-- ===================== ADD / EDIT MODAL ===================== -->
<p-dialog [visible]="showModal()" (visibleChange)="showModal.set($event)" [modal]="true"
    [draggable]="true" [resizable]="false" [closable]="true" [dismissableMask]="false"
    [header]="editing() ? 'Edit State' : 'Add State'" styleClass="menu-dialog"
    [style]="{ width: '460px' }" [breakpoints]="{ '460px': '94vw' }">
    <form [formGroup]="form" class="menu-form">
        <div class="field">
            <label>State Name <span class="req">*</span></label>
            <input pInputText type="text" formControlName="stateName" placeholder="e.g. Madhya Pradesh">
            @if (form.get('stateName')?.touched && form.get('stateName')?.invalid) {
                <small class="err">State name is required</small>
            }
        </div>

        <div class="field-row">
            <label>Active</label>
            <p-toggleswitch formControlName="isActive" />
        </div>

        <div class="modal-actions">
            <p-button label="Cancel" [outlined]="true" (onClick)="closeModal()" />
            <p-button label="Save" (onClick)="save()" [loading]="saving()" />
        </div>
    </form>
</p-dialog>
